(function(){
  if (window.__cfgSite) return; window.__cfgSite = true;
  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduce) root.classList.add('cfg-motion');

  function ready(fn){ if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function(){
    var headerSec = document.querySelector('.cfg-header-section');
    var firstHero = document.querySelector('#MainContent > .shopify-section:first-child .cfg-hero-photo');

    /* see-through navigation over a photo hero, solid after */
    if (firstHero && headerSec) root.classList.add('cfg-over-hero');
    function onScroll(){
      if (headerSec){
        var limit = firstHero ? Math.max(firstHero.offsetHeight - headerSec.offsetHeight - 10, 10) : 10;
        headerSec.classList.toggle('is-solid', !firstHero || window.scrollY > limit);
      }
      parallax();
    }

    /* dropdowns */
    var items = Array.prototype.slice.call(document.querySelectorAll('.cfg-menu > li'));
    function closeAll(except){ items.forEach(function(li){ if (li !== except){ li.classList.remove('open'); var b = li.querySelector('button'); if (b) b.setAttribute('aria-expanded','false'); } }); }
    var hover = window.matchMedia('(hover:hover)');
    items.forEach(function(li){
      var btn = li.querySelector('button'); if (!btn) return;
      btn.addEventListener('click', function(e){ e.stopPropagation(); var open = !li.classList.contains('open'); closeAll(li); li.classList.toggle('open', open); btn.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      li.addEventListener('mouseenter', function(){ if (hover.matches){ closeAll(li); li.classList.add('open'); btn.setAttribute('aria-expanded','true'); } });
      li.addEventListener('mouseleave', function(){ if (hover.matches){ li.classList.remove('open'); btn.setAttribute('aria-expanded','false'); } });
    });
    document.addEventListener('click', function(e){ if (!e.target.closest('.cfg-menu')) closeAll(); });

    /* mobile menu */
    var mm = document.getElementById('cfg-mm'), burger = document.getElementById('cfg-burger'), mmClose = document.getElementById('cfg-mm-close');
    function openMM(){ if (!mm) return; mm.classList.add('open'); mm.setAttribute('aria-hidden','false'); burger && burger.setAttribute('aria-expanded','true'); document.body.style.overflow='hidden'; mmClose && mmClose.focus(); }
    function closeMM(){ if (!mm || !mm.classList.contains('open')) return; mm.classList.remove('open'); mm.setAttribute('aria-hidden','true'); burger && burger.setAttribute('aria-expanded','false'); document.body.style.overflow=''; burger && burger.focus(); }
    burger && burger.addEventListener('click', openMM);
    mmClose && mmClose.addEventListener('click', closeMM);
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape'){ closeAll(); closeMM(); } });

    /* get support panel */
    var sheet = document.getElementById('cfg-support');
    document.addEventListener('click', function(e){
      var open = e.target.closest('[data-cfg-support]');
      if (open && sheet){ e.preventDefault(); closeMM(); if (sheet.showModal) sheet.showModal(); else sheet.setAttribute('open',''); }
      if (e.target.closest('[data-cfg-support-close]') && sheet){ sheet.close ? sheet.close() : sheet.removeAttribute('open'); }
    });
    sheet && sheet.addEventListener('click', function(e){ if (e.target === sheet) sheet.close(); });

    /* hero headline word-by-word */
    function splitHeroes(){
      document.querySelectorAll('.cfg-hero-photo__title').forEach(function(h){
        if (h.dataset.split) return; h.dataset.split = '1';
        var i = 0, out = [];
        h.setAttribute('aria-label', h.textContent.replace(/\s+/g,' ').trim());
        Array.prototype.slice.call(h.childNodes).forEach(function(node){
          if (node.nodeType === 3){ node.textContent.split(/(\s+)/).forEach(function(part){ if (!part) return; if (/^\s+$/.test(part)) out.push(' '); else out.push('<span class="w" aria-hidden="true" style="--i:' + (i++) + '">' + part + '</span>'); }); }
          else if (node.nodeName === 'BR') out.push('<br>');
          else out.push('<span class="w" aria-hidden="true" style="--i:' + (i++) + '">' + node.textContent + '</span>');
        });
        h.innerHTML = out.join('');
      });
      requestAnimationFrame(function(){ requestAnimationFrame(function(){ document.querySelectorAll('.cfg-hero-photo').forEach(function(h){ h.classList.add('is-in'); }); }); });
    }
    splitHeroes();

    /* scroll reveal: pieces of CFG sections rise in as you reach them */
    var sel = [
      '#MainContent .cfg .cfg-inner > *',
      '#MainContent .cfg [class*="grid"] > *',
      '#MainContent .cfg-stats > *', '#MainContent .cfg-cards > *', '#MainContent .cfg-truths > *',
      '#MainContent .cfg-rowlist > *', '#MainContent .cfg-values > *', '#MainContent .cfg-cols > *',
      '#MainContent .cfg-story__body .cfg-rte > p'
    ].join(',');
    function countUp(el){
      if (el.dataset.done) return; el.dataset.done = '1';
      var to = parseFloat(el.getAttribute('data-cfg-count')), suffix = el.getAttribute('data-cfg-suffix') || '';
      if (isNaN(to)) return;
      if (reduce){ el.textContent = to.toLocaleString('en-US') + suffix; return; }
      var start = null;
      function step(t){ if (!start) start = t; var p = Math.min((t - start) / 1400, 1), e = 1 - Math.pow(1 - p, 3); el.textContent = Math.round(to * e).toLocaleString('en-US') + suffix; if (p < 1) requestAnimationFrame(step); }
      el.textContent = '0' + suffix; requestAnimationFrame(step);
    }
    var io = null, co = null;
    if (!reduce && ('IntersectionObserver' in window)){
      io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){ if (!en.isIntersecting) return; en.target.classList.add('is-in'); io.unobserve(en.target); });
      }, {threshold: 0.12, rootMargin: '0px 0px -5% 0px'});
      co = new IntersectionObserver(function(entries){
        entries.forEach(function(en){ if (!en.isIntersecting) return; countUp(en.target); co.unobserve(en.target); });
      }, {threshold: 0.4});
    }
    function setupMotion(){
      var targets = Array.prototype.slice.call(document.querySelectorAll(sel)).filter(function(el){ return !el.closest('.cfg-hero-photo') && !el.closest('.cfg-nav') && !el.hasAttribute('data-cfg-reveal'); });
      targets.forEach(function(el){
        var idx = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
        el.setAttribute('data-cfg-reveal',''); el.style.setProperty('--cfg-d', idx % 4);
        if (io) io.observe(el); else el.classList.add('is-in');
      });
      document.querySelectorAll('[data-cfg-autocount]:not([data-cfg-count])').forEach(function(el){
        var m = el.textContent.trim().match(/^(\d[\d,]*)(.*)$/);
        if (!m || /^\s*[\u2013-]/.test(m[2])) return;
        el.setAttribute('data-cfg-count', m[1].replace(/,/g,'')); el.setAttribute('data-cfg-suffix', m[2]);
        if (co) co.observe(el); else countUp(el);
      });
    }
    setupMotion();

    /* gentle parallax on photo bands */
    function parallax(){
      if (reduce) return;
      var vh = window.innerHeight;
      document.querySelectorAll('[data-cfg-parallax]').forEach(function(img){
        var r = img.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var prog = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
        img.style.transform = 'translateY(' + (prog * -8).toFixed(2) + '%)';
      });
    }

    window.addEventListener('scroll', onScroll, {passive: true});
    window.addEventListener('resize', onScroll);
    document.addEventListener('shopify:section:load', function(){
      firstHero = document.querySelector('#MainContent > .shopify-section:first-child .cfg-hero-photo');
      root.classList.toggle('cfg-over-hero', !!firstHero);
      splitHeroes(); setupMotion(); onScroll();
    });
    onScroll();
  });
})();
